export default "__VITE_ASSET__f700b969__"